export default (base, prefix) => `${base}/${prefix}`;
